import React from "react";

export default class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }
  static getDerivedStateFromError() {
    return { hasError: true };
  }
  componentDidCatch(error, info) {
    console.error("Alpha OS crashed:", error, info);
  }
  render() {
    if (this.state.hasError) {
      return (
        <div className="min-h-screen flex flex-col items-center justify-center bg-[#0A0A0C] text-white text-center px-6" data-testid="error-boundary">
          <div className="h-16 w-16 rounded-2xl bg-gold/10 border border-gold/30 flex items-center justify-center mb-5">
            <span className="text-3xl">⚠️</span>
          </div>
          <h1 className="text-2xl font-display font-extrabold">Algo não carregou corretamente</h1>
          <p className="text-zinc-400 mt-2 max-w-sm">Tivemos um probleminha ao exibir esta tela. Clique abaixo para recarregar — seus dados estão salvos.</p>
          <button
            onClick={() => window.location.reload()}
            data-testid="error-reload-btn"
            className="mt-6 text-sm font-semibold text-black px-6 py-3 rounded-full"
            style={{ background: "linear-gradient(135deg,#F3C64F,#D4AF37 55%,#AA820A)" }}>
            Recarregar página
          </button>
        </div>
      );
    }
    return this.props.children;
  }
}
